<template>
  <div v-if="hasMessage">
    <div class="messenger__container h-center-align" :class="messageClass">
      <div class="messenger__title h-display-inline-block">
        <i class="fa" :class="iconClass"></i>
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SystemMessage',
    computed: {
      ...mapGetters('auth', ['error', 'message']),
      hasMessage() {
        return this.message && this.message != '';
      },
      messageClass() {
        return this.error ? 'messenger__container--error' : 'messenger__container--alert';
      },
      iconClass() {
        return this.error ? 'fa-times-circle h-error-text-color' : 'fa-check-circle h-success-text-color';
      }

    },

  }
</script>

